export const SCOPE = 'common';
export const RESET = `${SCOPE}/RESET`;
export const APPLY_FILTER = `${SCOPE}/APPLY_FILTER`;
export const ASYNC_HTTP_REQ_STARTED = `${SCOPE}/ASYNC_HTTP_REQ_START`;
export const ASYNC_HTTP_REQ_ENDED = `${SCOPE}/ASYNC_HTTP_REQ_END`;
export const ADD_NEW_DASHBOARD = `${SCOPE}/ADD_NEW_DASHBOARD`;
export const CHANGE_ACTIVE_DASHBOARD_ID = `${SCOPE}/CHANGE_ACTIVE_DASHBOARD`;
export const UPDATE_PROFILES = `${SCOPE}/UPDATE_PROFILES`;
export const INTERVAL_SELECTION = `${SCOPE}/INTERVAL_SELECTION`;
export const UPDATE_GRANULARITY = `${SCOPE}/UPDATE_GRANULARITY`;
export const TOGGLE_MODAL = `${SCOPE}/TOGGLE_MODAL`;
export const UPDATE_FEATURES = `${SCOPE}/UPDATE_FEATURES`;
export const UPDATE_APP_ALL_METRICS = `${SCOPE}/UPDATE_APP_ALL_METRICS`;
export const UPDATE_USER_DEFINED_METRICS = `${SCOPE}/UPDATE_USER_DEFINED_METRICS`;
export const SET_SHARING_STATE = `${SCOPE}/SET_SHARING_STATE`;
export const RESET_DIAGNOSTICS = `${SCOPE}/RESET_DIAGNOSTICS`;
export const CHANGE_COLLAPSE_STATUS = `${SCOPE}/CHANGE_COLLAPSE_STATUS`;
export const OPEN_COLLAPSE = `${SCOPE}/OPEN_COLLAPSE`;
export const CLOSE_COLLAPSE = `${SCOPE}/CLOSE_COLLAPSE`;
export const CHANGE_IS_SHARING_PAGE = `${SCOPE}/CHANGE_IS_SHARING_PAGE`;
export const SET_COMPARE_MODE = `${SCOPE}/SET_COMPARE_MODE`;
export const PERSIST_STATE = `${SCOPE}/PERSIST_STATE`;
export const UPDATE_PERSISTED_COMMON_STATE = `${SCOPE}/UPDATE_PERSISTED_COMMON_STATE`;
export const UPDATE_PERSISTED_COMMON_STATE_FOR_PRESET = `${SCOPE}/UPDATE_PERSISTED_COMMON_STATE_FOR_PRESET`;
export const REFRESH_TRENDS = `${SCOPE}/REFRESH_TRENDS`;
export const TOGGLE_LAYOUT = `${SCOPE}/TOGGLE_LAYOUT`;
export const SET_DIMENSION_TYPE_IN_FILTER = `${SCOPE}/SET_DIMENSION_TYPE_IN_FILTER`;
export const SET_APP_BACKEND_TYPE = `${SCOPE}/SET_APP_BACKEND_TYPE`;
export const SET_AI_ALERTS_SENSITIVITY = `${SCOPE}/SET_AI_ALERTS_SENSITIVITY`;
export const SET_AI_ALERTS_METRICS_META = `${SCOPE}/SET_AI_ALERTS_METRICS_META`;

/* TODO: For future reference,
 * Use below id in the editor to find the occurences of it's relative references.
 * Editor search key: dashboard_types_UUE93ID
 */
export const UPDATE_DASHBOARD_TYPE = `${SCOPE}/UPDATE_DASHBOARD_TYPE`;
export const CLOSE_ALL_TABS = `${SCOPE}/CLOSE_ALL_TABS`;
export const TOGGLE_ANNOTATIONS = `${SCOPE}/TOGGLE_ANNOTATIONS`;
export const SET_REAL_TIME_MODE = `${SCOPE}/SET_REAL_TIME_MODE`;
export const AI_ALERTS_DIMENSION_MAPPING = `${SCOPE}/AI_ALERTS_DIMENSION_MAPPING`;
